import type { ReactNode } from "react";
import { Button } from "@swot/base-components";

export function SwotBlockingDialog(props: { readonly title: string; readonly open?: boolean | undefined; readonly children?: ReactNode | undefined; readonly onClose?: (() => void) | undefined }) {
  if (props.open === false) return null;
  return (
    <section className="swot-blocking-dialog" role="dialog" aria-modal="true" aria-label={props.title}>
      <div className="swot-blocking-dialog__panel">
        <header className="swot-blocking-dialog__header"><strong>{props.title}</strong></header>
        <div className="swot-blocking-dialog__body">{props.children}</div>
        {props.onClose ? <Button label="Close" variant="secondary" onClick={props.onClose} /> : null}
      </div>
    </section>
  );
}
